const CardTypes = {
  Leader: 'leader_card',
  Content: 'content_card',
  List: 'list_card',
  MiniNav: 'mini_nav_card',
  InteractiveHTML: 'interactive_html_card',
}

export default Object.freeze(CardTypes);
